import Split from './../scroll/custom'

class FullHeight {
    constructor(windowSizes) {
        this.divs = document.querySelectorAll('.full-height');
        this.windowSizes = windowSizes;
        if (this.windowSizes.mobileDevice) {
            this.noVirtualScrollMobile()
        }

    }

    noVirtualScrollMobile() {
        document
            .body
            .classList
            .add('mobile-device')
    }

    init() {

        this.setHeight(this.windowSizes.height)

        if (!this.windowSizes.mobileDevice) {
            this.initScroll()
        }

    }

    setHeight(windowHeight) {
        Array.from(this.divs, (d, index) => {

            d.style.display = 'block'
            //d.style.opacity = 0
            d.style.height = 'auto'

            let divHeight = (d.offsetHeight > windowHeight)
                ? d.offsetHeight
                : windowHeight

            if (d.classList.contains('vs-min') || (d.classList.contains('vs-min-mobile') && this.windowSizes.mobileDevice)) {
                /* divHeight = (d.offsetHeight === 0)
                    ? windowHeight
                    : d.offsetHeight*/
            } else {
                d.style.height = divHeight + 'px'
            }

            //console.log(index, d.offsetHeight, windowHeight, divHeight)

        });
    }

    initScroll() {
        const scroll = new Split({
            preload: true,
            native: true,
            section: document.querySelector('.vs-section'),
            sections: document.querySelectorAll('.vs-split'),
            divs: document.querySelectorAll('.vs-div')
        })
        scroll.init()
    }

    resize(windowSizes) {
        if (windowSizes !== this.windowSizes && windowSizes.width !== this.windowSizes.width) {
            //console.log('resize');
            this.windowSizes = windowSizes;
            this.setHeight(this.windowSizes.height);
        }
    }
}

export default FullHeight;


// WEBPACK FOOTER //
// ./src/js/components/FullHeight.js